export const handleSsrQuery =
  <T1, T2, U>(fn: (args: T1, options?: T2) => Promise<U>) =>
  (suppliedArgs: T1, suppliedOptions?: T2) =>
  (queryClientOptions: T2): Promise<U> =>
    fn(suppliedArgs, { ...suppliedOptions, ...queryClientOptions })
